module.exports = __webpack_public_path__ + "img/bit-treasure-1.96277dda.png";